import React from "react";
import "./Proyectos.css";
import Card from "./Card.jsx";
import PI from "./PI.png";
import final from "./final.png";
import sm from "./SM.png";
import prode from "./prode.png";
import tucdle from "./tucdle.png";
import planilla from "./planilla.png";
import impulsa from "./impulsa.png";
import compras from "./compras.png";
import mastri from "./mastri.png";
import fund from "./fund.png";
import todolist from "./todolist.png";
import victoria from "./victoria.png";
import WP from "./WP.png";
function Proyectos() {
  return (
    <div>
      <h1 className="titulo">Proyectos Realizados</h1>
      <h3 className="titulo">Full stack React - Node</h3>
      <div className="contenedor-proyectos">
        <Card
          nombre="Proyecto Individual VideoGames- Soy Henry"
          link="https://pi-soy-henry-vg.vercel.app/"
          imagen={PI}
        />

        <Card
          nombre="Proyecto Final - Soy Henry"
          link="https://proyecto-final-orcin-seven.vercel.app/"
          imagen={final}
        />

        <Card
          nombre="Sistema de Turnos - SM Salud y Belleza"
          link="https://smdepilacion-ffcea.web.app/"
          imagen={sm}
        />

        <Card
          nombre="Pronostico Qatar 2022 - Proyecto Full Stack"
          link="https://www.youtube.com/watch?v=XXTCl55Au_4"
          imagen={prode}
        />

        <Card
          nombre="Clon Juego Wordle - Proyecto Full Stack"
          link="https://youtu.be/QFKQFjqz64s"
          imagen={tucdle}
        />

        <Card
          nombre="Planilla Equipo de Fútbol - Proyecto Full Stack"
          link="https://youtu.be/HyeoiyjmrcA"
          imagen={planilla}
        />

        <Card
          nombre="Proyecto ToDoList - "
          link="https://todolist-three-khaki.vercel.app/"
          imagen={todolist}
        />
        <Card 
        nombre = 'Clon WhatsApp'
        link= 'https://www.youtube.com/watch?v=vMaQrOSfFUE'
        imagen ={WP}
        />
      </div>
      <h1 className="titulo">Proyectos Realizados</h1>
      <h3 className="titulo">Wordpress</h3>
      <div className="contenedor-proyectos">
        <Card
          nombre="Impulsa Redes - Wordpress"
          link="https://impulsaredes.com/"
          imagen={impulsa}
        />

        <Card
          nombre="Compras en Cripto - Wordpress"
          link="https://comprasencripto.com/"
          imagen={compras}
        />
        <Card
          nombre="MastriTurismo - Wordpress"
          link="https://mastriturismo.com.ar/"
          imagen={mastri}
        />

        <Card
          nombre="Fundacion Branex - Wordpress"
          link="https://fundacionbranex.org.ar/"
          imagen={fund}
        />

        <Card
          nombre="Victoria Style - Wordpress"
          link="https://www.victoria-style.com/"
          imagen={victoria}
        />
      </div>
    </div>
    // </div>
  );
}

export default Proyectos;
